import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_auto_email_inventory_below_minimum_thresholdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { minimum_inventory_threshold_base_amount: number, projectId: number, rule_id: string, warehouse_id: number, $top?: number, $skip?: number }): Promise<{ result?: { material_id?: number, lookup?: string, description?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.minimum_inventory_threshold_base_amount)) {
      missingRequiredInParams.push('\'minimum_inventory_threshold_base_amount\'');
    }
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil(inParams.rule_id)) {
      missingRequiredInParams.push('\'rule_id\'');
    }
    if (isNil(inParams.warehouse_id)) {
      missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_auto_email_inventory_below_minimum_threshold/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { minimum_inventory_threshold_base_amount?: number, projectId?: number, rule_id?: string, warehouse_id?: number, $keys: number[] }): Promise<{ result?: { material_id?: number, lookup?: string, description?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_auto_email_inventory_below_minimum_threshold/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      minimum_inventory_threshold_base_amount: number, projectId: number, rule_id: string, warehouse_id: number    }) {
        if(isNil(inParams.minimum_inventory_threshold_base_amount)) {
          return true; 
        }
        if(isNil(inParams.projectId)) {
          return true; 
        }
        if(isNil(inParams.rule_id)) {
          return true; 
        }
        if(isNil(inParams.warehouse_id)) {
          return true; 
        }
      return false;
    }
}
